import IStripe from './IStripe'
import ICyberSource from './ICyberSource'

export const SalesTaxesTypeArray = ['ADOPTION_FEE', 'ADDITION',"DISCOUNT", 'DONATION', 'FIXED_FEE', 'VOUCHER', 'TAX', 'LICENSE', 'PRODUCT', 'SPAY_NEUTER'] as const
export type SalesTaxesType = typeof SalesTaxesTypeArray[number]

export default interface IShelterPaymentConfig {
  payment_model_key: string,
  update_pets_payment_model?: boolean,
  payment_type: string,
  stripe?: IStripe | null,
  cybersource?: ICyberSource | null,
  sales_taxes?: Record<SalesTaxesType, number>
}
